import { forwardRef } from "react";
import { cn } from "@/lib/utils";

export const Input = forwardRef<HTMLInputElement, React.InputHTMLAttributes<HTMLInputElement>>(
  function Input({ className, ...props }, ref) {
    return (
      <input
        ref={ref}
        className={cn(
          "flex h-10 w-full rounded border border-brand-outline-variant/60 bg-brand-surface-lowest px-3 py-2 text-sm text-brand-ink ring-offset-brand-surface placeholder:text-brand-outline focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand-primary",
          className,
        )}
        {...props}
      />
    );
  },
);

export const Textarea = forwardRef<
  HTMLTextAreaElement,
  React.TextareaHTMLAttributes<HTMLTextAreaElement>
>(function Textarea({ className, ...props }, ref) {
  return (
    <textarea
      ref={ref}
      className={cn(
        "flex min-h-[120px] w-full rounded border border-brand-outline-variant/60 bg-brand-surface-lowest px-3 py-2 text-sm text-brand-ink ring-offset-brand-surface placeholder:text-brand-outline focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand-primary",
        className,
      )}
      {...props}
    />
  );
});

export function Label({ className, ...props }: React.LabelHTMLAttributes<HTMLLabelElement>) {
  return <label className={cn("text-sm font-medium text-brand-ink", className)} {...props} />;
}
